import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { alert_error, alert_success } from "../../AppContext.js";
import { RingLoader, MoonLoader } from "react-spinners";
import Language_i18 from '../../js/useNationalLanguage.jsx';

const Category = () => {
    const { slug_2 } = useParams();
    const categoryUri = slug_2
        ? (slug_2.endsWith('_old') ? slug_2.slice(0, -4) : slug_2)
        : 'tips_vip';
    const { lang } = Language_i18();
    const latest_version = useSelector((state) => state.latest_version);
    const [content, setcontent] = useState('');
    const [error, seterror] = useState('');
    const [imageErrors, setImageErrors] = useState({});
    const navigate = useNavigate();
    function switch_router(link) {
        navigate('/shop/posts/' + link);
    };
    const fetchData = () => {
        if (categoryUri) {
            axios.get('https://hust.media/api/content/getdata_v2.php?uri=' + categoryUri + '&mode=category')
                .then((response) => {
                    testFunction(response);
                })
                .catch((error) => {
                    alert_error(error);
                });
        }
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;

        if (status == 1) {
            const data = info.data;
            console.log(data);
            if (latest_version != 3) alert_success(message);
            setcontent(data);
        }
        else if (status == 0) {
            alert_error(message);
            seterror(message);
        }
        else {
            alert_error(translations[lang]?.unknownError || translations.vi.unknownError);
            seterror(translations[lang]?.unknownError || translations.vi.unknownError);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    const translations = {
        vi: {
            title: "Latest Insights",
            readMore: "Đọc thêm",
            writtenDate: "Ngày viết:",
            unknownError: "Đã xảy ra lỗi không xác định vui lòng liên hệ admin"
        },
        en: {
            title: "Latest Insights",
            readMore: "Read more",
            writtenDate: "Written date:",
            unknownError: "An unknown error occurred, please contact admin"
        }
    };
    const handleShareButtonClick = async () => {
        try {
            await navigator.share({
                title: content.title,
                text: content.description,
                url: window.location.href
            });
        } catch (error) {
            console.error('Lỗi khi chia sẻ:', error);
        }
    };
    const posts = [
        {
            id: 1,
            image: 'https://golike.net/wp-content/uploads/2021/11/kiem-tien-online.jpeg',
            title: 'Bài đăng 1',
            description: 'Mô tả bài đăng 1'
        },
        {
            id: 2,
            image: 'https://golike.net/wp-content/uploads/2021/11/thu-thuat.jpg',
            title: 'Bài đăng 2',
            description: 'Mô tả bài đăng 2'
        },
        {
            id: 3,
            image: 'https://golike.net/wp-content/uploads/2021/11/huong-dan.jpeg',
            title: 'Bài đăng 3',
            description: 'Mô tả bài đăng 3'
        }
    ];
    return (
        <>
            {!content && !error ? (<div className="mt-2 flex justify-center items-center">
                <MoonLoader size={75} color="#003AA5" />{" "}
            </div>
            ) : (<>
                {
                    content ? (
                        <>
                            <Helmet>
                                <title>{translations[lang]?.title || translations.vi.title}</title>
                            </Helmet>
                            <div className="mx-3 mt-2 mb-4">
                                <h2 className="text-center font-bold mb-2 mt-2">{translations[lang]?.title || translations.vi.title}</h2>
                                <p className="mx-auto mb-4 max-w-3xl text-center text-base text-slate-600">
                                    A curated hub of technical guides, architecture notes, and practical build references—organized for quick reading, easy sharing, and real-world implementation.
                                </p>
                                {content.map(post => {
                                    const thumbnailImage = typeof post.thumbnail_image === "string"
                                        ? post.thumbnail_image.trim()
                                        : "";
                                    const cardImage = thumbnailImage !== "" ? thumbnailImage : post.image;
                                    return (
                                        <div className="container mx-auto rounded-3xl overflow-hidden shadow-lg bg-pink-100 bg-opacity-50">
                                            <div className="flex items-center justify-between px-0 py-2">
                                                <div className="ml-1 w-1/4">
                                                    {(!cardImage || imageErrors[post.uri || post.id]) ? (
                                                        <div className="max-h-48 h-24 flex items-center justify-center rounded-md bg-white/70 text-gray-700 text-sm font-semibold">
                                                            {post.title}
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={cardImage}
                                                            alt={post.title}
                                                            className="block max-h-48 object-cover mx-auto"
                                                            onError={() => setImageErrors((prev) => ({ ...prev, [post.uri || post.id]: true }))}
                                                        />
                                                    )}
                                                </div>
                                                <div className="w-3/4 ml-2 mr-4">
                                                    <div className="border-l-4 border-gray-500 pl-4">
                                                        <h2 className="text-2xl font-bold mb-2">{post.title}</h2>
                                                        <p className="text-gray-700">{post.description}</p>
                                                        <div className="mt-2 mb-2">
                                                            <Link
                                                                to={`/shop/posts/${post.uri}`}
                                                                style={{ textDecoration: 'none' }}
                                                            >
                                                                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                                                                    {translations[lang]?.readMore || translations.vi.readMore}
                                                                </button>
                                                            </Link>
                                                        </div>
                                                        <p className="text-sm text-gray-500">
                                                            <span>{translations[lang]?.writtenDate || translations.vi.writtenDate} {post.createdate}</span>
                                                            {(post.tips_hash_name || post.category) && (
                                                                <span className="ml-3">{post.tips_hash_name || post.category}</span>
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    ) :
                        (
                            error ? <><div className="mt-5 text-center text-xl font-bold">
                                {error}
                            </div></> :
                                null
                        )
                }
            </>)
            }
        </>
    )
}

export default Category;
